/**
 * Slim "founding member" promo strip shown on the pricing pages when
 * the admin enables it from /admin/growth. Reads the public flag —
 * renders nothing while disabled.
 */
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TagIcon as Tag } from "@phosphor-icons/react";

export default function FoundingPromoBanner() {
  const [promo, setPromo] = useState(null);
  useEffect(() => {
    api.get("/public/founding-promo")
      .then((r) => { if (r.data?.enabled) setPromo(r.data); })
      .catch(() => {});
  }, []);
  if (!promo) return null;
  return (
    <div
      className="bg-ink text-white"
      data-testid="founding-promo-banner"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-2.5 flex items-center justify-center gap-2 text-center text-[13px]">
        <Tag size={14} weight="fill" className="text-gold flex-shrink-0" />
        <span>
          {promo.message} — use code{" "}
          <strong className="text-gold tracking-wider">{promo.code}</strong> at checkout.
        </span>
      </div>
    </div>
  );
}
